module.exports = __webpack_public_path__ + "static/media/accueilAnim.089b80dc.gif";